<template>
  <div id="contenedor-eliminar-contrato-tema">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Tema </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar el tema: {{contratoTemaEliminar.descripcion}}?
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
        </custom-button>
        <custom-button
          @click="mixEliminarTema"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixTemasContrato from './mixTemasContrato';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarTemaContrato',
  mixins: [mixTemasContrato],
  props: {
    contratoTemaEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style></style>
